<script>import { page } from "$app/stores";
import { cfgBrandTitle, cfgToThemeContentPath } from "@infinitro/config";
import { betbyCurrentRoute, locale, loggedIn } from "@infinitro/global";
import CdnSeoMarkdownPanel from "./cdn-seo-markdown-panel.svelte";
import {
  applyStaticSeoPlaceholders,
  fetchLocaleRawWithEnFallback,
  renderSeoMarkdown
} from "./fetch-markdown-seo";
const BRAND_NAME = cfgBrandTitle();
export let showMoreButton = true;
function extractSportSlug(path) {
  const parts = path.split("/").filter(Boolean);
  const sportsIndex = parts.indexOf("sports");
  if (sportsIndex < 0) return "";
  return parts[sportsIndex + 1] || "sports";
}
$: pathSportSlug = extractSportSlug($page.url.pathname);
$: betbySportSlug = extractSportSlug($betbyCurrentRoute || "");
$: sportSlug = pathSportSlug || betbySportSlug;
let htmlContent = "";
let lastModified = "";
$: hasContent = htmlContent.trim().length > 0;
let fetchId = 0;
function sportsCdnPath(slug, loc) {
  if (slug === "sports")
    return {
      localeUrl: cfgToThemeContentPath(`/seo/sports/sports.${loc}.md`),
      enUrl: cfgToThemeContentPath(`/seo/sports/sports.en.md`)
    };
  return {
    localeUrl: cfgToThemeContentPath(`/seo/sports/${slug}/${slug}.${loc}.md`),
    enUrl: cfgToThemeContentPath(`/seo/sports/${slug}/${slug}.en.md`)
  };
}
$: if ($loggedIn === false && sportSlug) {
  const id = ++fetchId;
  const loc = $locale;
  const { localeUrl, enUrl } = sportsCdnPath(sportSlug, loc);
  fetchLocaleRawWithEnFallback(localeUrl, enUrl, { cacheBust: true }).then(
    ({ raw, lastModified: lm }) => {
      if (id !== fetchId || $loggedIn !== false) return;
      htmlContent = renderSeoMarkdown(applyStaticSeoPlaceholders(raw, BRAND_NAME));
      lastModified = lm;
    }
  );
} else {
  htmlContent = "";
  lastModified = "";
}
</script>

<svelte:head>
	{#if lastModified}
		<meta property="article:modified_time" content={lastModified} />
	{/if}
</svelte:head>

{#if hasContent}
	<CdnSeoMarkdownPanel variant="contained" {htmlContent} {lastModified} {showMoreButton} />
{/if}
